import ListComponent from "./ListComponent"

const Nurses = () => {
    return (
        <ListComponent type="nurse" />
    )
}

export default Nurses